
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { TreeNodeObject } from '~/interfaces/helper.interface';
import TreeMixin from '~/mixins/tree.mixin';
import { ConfigModule } from '~/store/modules/config';
import { encodeUriDeviceId } from '~/helpers';

@Component
export default class TreeNode extends Mixins(TreeMixin) {
    @Prop() readonly item!: TreeNodeObject;
    @Prop() readonly openSync!: string[];
    @Prop() readonly isInAHome!: boolean;

    get openSyncComputed() {
        return this.openSync;
    }

    set openSyncComputed(val: string[]) {
        this.$emit('update-opened-nodes', val);
    }

    handleItemClick(item: TreeNodeObject) {
        if (item.canBeActive) {
            this.scrollToTop();
            return this.navigateTo(item, this.isInAHome);
        }
    }

    scrollToTop() {
        const scrollingDiv = document.getElementById('info-blocks');
        if (scrollingDiv) {
            scrollingDiv.scrollTop = 0;
        }
    }

    async navigateTo(item: TreeNodeObject, isInAHome = true) {
        const path = this.buildPath(item, isInAHome);
        if (path === this.$route.path) {
            return;
        }
        this.$router.push({ path });
        this.openTreeNode(item.id);
    }

    openTreeNode(id: string) {
        // show children of element by adding its id to the array of open elements
        if (!this.openSync.find((el: string) => el === id)) {
            this.openSync.push(id);
        }
    }

    buildPath(item: TreeNodeObject, isInAHome: boolean) {
        const { userIdentifier } = this.$route.params;
        let { id, type, homeId, gatewayId } = item;

        id = encodeUriDeviceId(id) || '';
        gatewayId = encodeUriDeviceId(gatewayId || '');
        let path = `/${ConfigModule.supportAppNameBase}${userIdentifier ? '/user/' + userIdentifier : ''}`;

        switch (type) {
            case 'home':
                path = `${path}/home/${id}`;
                break;
            case 'gateway':
                path = isInAHome
                    ? `${path}/home/${homeId}/gateway/${id}`
                    : `${path}/gateway/${id}`;
                break;
            case 'module':
                path = isInAHome
                    ? `${path}/home/${homeId}/gateway/${gatewayId}/module/${id}`
                    : `${path}/gateway/${gatewayId}/module/${id}`;
                break;
        }
        return path;
    }
}
